import React from 'react';
import { Container } from './styles';
import { CircularProgress } from '@material-ui/core';

export default function LoadingSection() {
  return (
    <Container>
      <CircularProgress size={36} style={{ color: '#ff7417' }} />
    </Container>
  )
}